
export interface VariableDescriptor {
    kind: 'local' | 'server';
    name:string;
    description: string;
    content?:string;
}

/**
 * Provides available variables 
 * (currently not a real hook, just a placeholder to identify where the hook could be needed)
 */
export const useAvailableVariables = (): VariableDescriptor[] => {
    return [
        {
            kind:'local',
            'name': 'weekly_button',
            'description':'Create the button with link to connect on the weekly survey'
        },
        {
            'kind': 'local',
            'name': 'style_button',
            'description': 'css style to for button ui'
        },
        {
            'kind': 'local',
            'name': 'style_code',
            'description': 'css style to for a security code'
        },
    ];
};